import template from './editProjectInfoModal.html';
import controller from './editProjectInfoModal.controller';

let editProjectInfoModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
editProjectInfoModalComponent.template = template;
editProjectInfoModalComponent.controller = controller;

export default editProjectInfoModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/editProjectInfoModal/editProjectInfoModal.component.js